import React from "react";
import { ReactComponent as Cross } from "../../assets/icons/Cross.svg";
import { ApiCall } from "../../Redux/Actions/ApiCall";
import { urls } from "../../Utils/url";
import { toast } from "react-toastify";
export const errors = {
  phoneIsEmpty: "لطفا شماره موبایل خود را وارد کنید",
  phoneNotValid:
    "شماره موبایل وارد شده صحیح نمی باشد. لطفا مجددا و با دقت وارد نمایید.",
  codeNotCorrect: "کد وارد شده نادرست است"
};

export const validatePhone = phone => {
  var PHONE = /^([0]{0,1})([9]{1})([0-9]{9})$/;
  return PHONE.test(phone);
};

const sendCode = async (phoneNumber, setIsCodeInput, setSentCode) => {
  const body = { mobile_number: phoneNumber };
  ApiCall("post", urls.verfiyCode, body, "sendVerifySms", null, function(e) {
    // toast.success(e.data, {
    //   position: "top-center",
    //   autoClose: 5000
    // });
    setSentCode(e.data);
    setIsCodeInput(true);
  });
};

const Login = async (
  code,
  phoneNumber,
  setToken,
  login,
  loginClose,
  getMobile,
  getUser
) => {
  const body = { mobile_number: phoneNumber, code: code, platform: "web" };
  ApiCall("post", urls.Login, body, "Login", null, function(e) {
    setToken(e.data.token);
    getMobile(phoneNumber);
    getUserData(getUser, e.data.token);
    login();
    loginClose();
  });
};

export const onClickSendCode = (
  setError,
  setIsCodeInput,
  phoneNumber,
  setPhoneIsValid,
  setSentCode
) => {
  if (phoneNumber !== "") {
    if (validatePhone(phoneNumber)) {
      setPhoneIsValid(true);
      setError("");
      sendCode(phoneNumber, setIsCodeInput, setSentCode);
    } else {
      setError(errors.phoneNotValid);
      setPhoneIsValid(false);
    }
  } else {
    setError(errors.phoneIsEmpty);
    setPhoneIsValid(false);
  }
};

export const onClickLogin = (
  loginClose,
  login,
  code,
  phoneNumber,
  setToken,
  getMobile,
  getUser
) => {
  Login(code, phoneNumber, setToken, login, loginClose, getMobile, getUser);
};

export const getUserData = (getUser, token) => {
  ApiCall("get", urls.User, null, "getUser", token, function(e) {
    getUser(e.data);
  });
};

export const LoginHeader = ({ loginClose }) => {
  return (
    <div className="LoginHeader">
      <span>احراز هویت</span>
      <div onClick={loginClose}>
        <Cross />
      </div>
    </div>
  );
};

export const PhoneInput = ({ onTextChange, onClickSendCode, error }) => {
  return (
    <>
      <span>
        برای ثبت نام رایگان و ادامه فرایند استعلام قبض شماره موبایل خود را وارد
        کنید
      </span>
      <input
        className="textInput"
        type="tel"
        autoComplete="off"
        id="phone"
        maxLength={12}
        placeholder="شماره همراه"
        onChange={v => onTextChange(v.target.value)}
      />
      <input
        type="submit"
        className="LoginButton"
        value="ارسال کد"
        onClick={onClickSendCode}
      />
      {error !== "" && <span className="LoginError">{error}</span>}
    </>
  );
};

export const Input = ({
  isCodeInput,
  onTextChange,
  onClickLogin,
  error,
  onClickSendCode,
  setCodeInput
}) => {
  if (isCodeInput) {
    return (
      <CodeInput
        onTextChange={onTextChange}
        error={error}
        onClickLogin={onClickLogin}
        setCodeInput={setCodeInput}
      />
    );
  } else {
    return (
      <PhoneInput
        onTextChange={onTextChange}
        error={error}
        onClickSendCode={onClickSendCode}
      />
    );
  }
};

export const CodeInput = ({
  onTextChange,
  onClickLogin,
  error,
  setCodeInput
}) => {
  return (
    <>
      <span>لطفا کد ارسال شده را وارد نمایید</span>
      <input
        className="textInput"
        type="tel"
        id="phone"
        autoComplete="off"
        placeholder="کد تایید"
        onChange={v => onTextChange(v.target.value)}
      />
      <input
        type="submit"
        className="LoginButton"
        value="ورود"
        onClick={onClickLogin}
      />
      <span onClick={() => setCodeInput()}>
        شماره تلفن را اشتباه وارد کرده اید؟
      </span>
      {error !== "" && <span className="LoginError">{error}</span>}
    </>
  );
};
